import React, { useState } from "react";

const mapSrc =
  "https://www.google.com/maps?q=4Ter%20rue%20d'Orange,%2037400%20Amboise&output=embed";

const schedules = [
  { day: "Lundi", hours: "Fermé" },
  { day: "Mardi", hours: "Fermé" },
  { day: "Mercredi", hours: "11H00 - 13H00 / 14H00 - 19H00" },
  { day: "Jeudi - Vendredi", hours: "14h00 - 20h00" },
  { day: "Samedi", hours: "10h00 - 13H00 / 14H00 - 20h00" },
  { day: "Dimanche", hours: "11H00-13H00 / 14H00 - 18H00" },
];

function Contact() {
  const [mapLoaded, setMapLoaded] = useState(false);

  return (
    <div className="w-full bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8 lg:px-12 py-12 flex flex-col gap-10">
        <header className="text-center">

          <h1 className="text-xl md:text-xl font-bold text-orange-900 mt-2">
            Une question, une demande particulière, un petit mot ? Contactez-nous l 
          </h1>

        </header>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
          <div className="w-full h-72 md:h-80 lg:h-full min-h-[320px] overflow-hidden rounded-2xl shadow-lg bg-orange-50">
            {mapLoaded ? (
              <iframe
                title="Localisation MOOD"
                src={mapSrc}
                width="100%"
                height="100%"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full h-full border-0"
              />
            ) : (
              <button
                onClick={() => setMapLoaded(true)}
                className="w-full h-full flex flex-col items-center justify-center gap-3 bg-orange-50 hover:bg-orange-100 transition cursor-pointer"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 text-[#F36D26]" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"/>
                </svg>
                <span className="text-sm text-[#F36D26] font-medium">Afficher la carte</span>
                <span className="text-xs text-gray-400 px-6 text-center">
                  En cliquant, vous acceptez le chargement de Google Maps (Google LLC).
                </span>
              </button>
            )}
          </div>

          <div className="flex flex-col gap-6 bg-white border border-orange-100 rounded-2xl shadow-sm p-6 md:p-8">
            <div>
              <h2 className="text-xl font-bold text-slate-900">Adresse</h2>
              <p className="text-slate-700 mt-2 leading-relaxed">
                4Ter rue d&apos;Orange
                <br />
                37400 Amboise
              </p>
            </div>

            <div className="flex flex-col gap-2 text-slate-700">
              <p>
                <span className="font-semibold text-orange-600">Téléphone :</span>{" "}
                <a href="tel:0246468573" className="hover:text-orange-600">
                  02 46 46 85 73
                </a>
              </p>
              <p>
                <span className="font-semibold text-orange-600">Email :</span>{" "}
                <a href="mailto:contact@mood.com" className="hover:text-orange-600">
                  contact@mood-cafe-atelier.com
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="bg-orange-50 border border-orange-100 rounded-2xl p-6 md:p-8">
          <h2 className="text-xl font-bold text-slate-900 mb-4">Horaires</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-slate-700">
            {schedules.map((item) => (
              <div
                key={item.day}
                className="flex items-center justify-between bg-white rounded-xl px-4 py-3 shadow-sm"
              >
                <span className="font-semibold text-orange-600">{item.day}</span>
                <span>{item.hours}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
